import React from 'react';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './button.scss';

const BugReportButton = () => {
    function reportLink() {
        window.open("https://docs.google.com/forms/d/e/1FAIpQLSevbJkD_X1qpgJQVIZmBr5pR319JnXBU0w038GrnIqToivBcg/viewform?usp=sf_link", "_blank");
    }

    return (
            <button
                onClick={reportLink}
                className="button-two flex items-center justify-center w-16 h-16 bg-red-600 text-white rounded-full shadow-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-offset-2"
                aria-label="Report a bug"
            >
                <i className="fas fa-bug"></i>
                <div className="tooltip">Report Bug</div>
            </button>
    );
};

export default BugReportButton;
